

































import Vue from 'vue';
import FaIcon from '@/components/FaIcon.vue';

export default Vue.extend({
  components: {
    FaIcon,
  },
  methods: {
    onClickDesign() {
      this.$emit('click-design');
    },
    onClickShare() {
      this.$emit('click-share');
    },
    onClickPDF() {
      this.$emit('click-pdf');
    },
  },
});
